import React from 'react';
import Img from 'gatsby-image';
import styled from '@emotion/styled';
import {
  rgba, timingFunctions, adjustHue, mix
} from 'polished';
import dayjs from 'dayjs';
import { view } from 'react-easy-state';

import { baseStore } from '../../store';

import { isEmpty } from '../../utils';
import { infoOverlay, HiddenText } from '../elements';
import { colors } from '../../styles/theme';

@view
export default class Video extends React.Component {
  render() {
    const {
      video, gap
    } = this.props;

    return (
      <CellWrapper
        gap={gap}
      >
        <CellInner
          id={video.id}
        >
          <Img
            fluid={video.featured_media.localFile.childImageSharp.fluid}
            css={{
              height: 0,
              position: 'relative',
              paddingBottom: 'calc(100% / (16 / 9))',
            }}
          />
          <Info>
            <h2
              css={{
                display: 'flex',
                fontSize: '1.25rem',
                lineHeight: 1,
                letterSpacing: -1,
                marginBottom: 3
              }}
            >
              {video.title}
              <div css={{ flex: 1 }} />
            </h2>
            <div
              css={{
                fontSize: '0.65rem',
                fontWeight: 600,
                textTransform: 'uppercase',
                lineHeight: 1,
                letterSpacing: 1,
                opacity: 0.7
              }}
            >
              Published on {dayjs(video.acf.released).format('MMM D, YYYY')}
            </div>
            <div css={{ flex: 1 }} />
            <p
              css={{
                display: 'flex',
                fontSize: '0.75rem',
                margin: 0,
                paddingTop: 7,
                fontWeight: 600,
                textTransform: 'uppercase',
                lineHeight: 1,
                letterSpacing: 1,
              }}
            >
              <span>{video.acf.artist}</span>
              {!isEmpty(video.acf.artist) && !isEmpty(video.acf.duration) && (
                <span css={{ flex: 1 }} />
              )}
              <span>{video.acf.duration}</span>
            </p>

            {!isEmpty(video.acf.description) && (
              <p
                css={{
                  fontSize: '0.7rem',
                  margin: 0,
                  paddingTop: 4,
                  fontWeight: 400,
                  lineHeight: 1.2,
                }}
              >
                {video.acf.description}
              </p>
            )}
          </Info>
          <Play
            href={video.acf.video}
            target="_blank"
            rel="noopener noreferrer"
            onClick={baseStore.openVideo}
          >
            <i className="fas fa-play" />
            <HiddenText>Play</HiddenText>
          </Play>
        </CellInner>
      </CellWrapper>
    );
  }
}

const Info = styled.div`
  ${infoOverlay}
  color: #fff !important;
`;

const playButtonSize = 2.5;

const Play = styled.a`
  position: absolute;
  top: calc(50% - 1.25em);
  left: calc(50% - 1.25em);
  display: flex;
  width: 2.5em;
  height: 2.5em;
  font-size: 1.25rem;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: ${colors.primary};
  color: #fff !important;
  transition: all 0.2s ease;
  opacity: 0;

  i {
    margin-left: 4px;
  }

  &:hover {
    transform: scale(1.1);
    transition: all 0.2s ease !important;
  }

  @media (max-width: 480px) {
    opacity: 1;
  }
`;

const CellWrapper = styled.div`
  padding: 0 ${p => p.gap}px;
  flex-shrink: 0;
  ${'' /* ${widthsVideos()} */}
  position: relative;
  overflow: hidden;
  width: 100%;
`;

const CellInner = styled.div`
  position: relative;
  overflow: hidden;

  &:hover {
    ${Info} {
      opacity: 1;
      transform: scale(1);
      transition: all 0.5s ${timingFunctions('linearSpring')};
    }

    ${Play} {
      opacity: 1;
      transition: all 0.5s ${timingFunctions('linearSpring')} 0.2s;
    }
  }
`;
